import { Phone, MessageCircle, FileText } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function FloatingDock() {
  const { waLink, telLink, openQuote } = useSite();
  return (
    <>
      {/* Desktop floating WhatsApp */}
      <a href={waLink()} target="_blank" rel="noreferrer" data-testid="floating-whatsapp-button"
        className="hidden lg:flex fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.5)] hover:scale-110 transition-transform">
        <MessageCircle className="text-white" size={26} />
      </a>

      {/* Mobile sticky bottom bar */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-3 bg-[#060B11]/95 backdrop-blur-xl border-t border-white/10" data-testid="mobile-action-bar">
        <a href={telLink} data-testid="mobile-call-button" className="flex flex-col items-center py-2.5 text-slate-200 active:bg-white/5">
          <Phone size={20} /><span className="text-[11px] mt-1">Call</span>
        </a>
        <a href={waLink()} target="_blank" rel="noreferrer" data-testid="mobile-whatsapp-button" className="flex flex-col items-center py-2.5 text-[#25D366] active:bg-white/5">
          <MessageCircle size={20} /><span className="text-[11px] mt-1">WhatsApp</span>
        </a>
        <button onClick={() => openQuote("Mobile Bar")} data-testid="mobile-quote-button" className="flex flex-col items-center py-2.5 text-emerald-400 active:bg-white/5">
          <FileText size={20} /><span className="text-[11px] mt-1">Get Quote</span>
        </button>
      </div>
    </>
  );
}
